var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcc7d0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.27,4.46h16v12H4.44L3.27,17.63V4.46h0m0-2a2,2,0,0,0-2,2v18l4-4h14a2,2,0,0,0,2-2v-12a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.27 12.46 17.27 12.46 17.27 14.46 5.27 14.46 5.27 12.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.27 9.46 17.27 9.46 17.27 11.46 5.27 11.46 5.27 9.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.27 6.46 17.27 6.46 17.27 8.46 5.27 8.46 5.27 6.46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.8be0d5392f36f19ccf32e73879b4b962.svg";
export { ForwardRef as ReactComponent };